<template>
    <div>
        <div class="row">
            <div class="col-lg-6">
                <AdminBlock title="Collection">
                    <fieldset class="">
                        <div class="form-group mb-4">
                            <label for="collection_date">
                                <strong>
                                    Collection Date
                                </strong>
                            </label>
                            <div class="input-group datetime collection-date">
                                <span class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                <input
                                    class="form-control js-flatpickers"
                                    placeholder="yyyy-mm-dd"
                                    id="collection_date"
                                    name="collection_date"
                                    v-model="state.collectionDate"
                                    type="date"
                                >
                            </div>
                        </div>

                        <div class="form-group mb-4">
                            <JobTime
                                title="Collection Time"
                                :time="state.collectionTime"
                                @update-time="time => { state.collectionTime = time }"
                            />
                        </div>

                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Collection Location
                                </strong>
                            </label>
                            <GoogleMap
                                map-for="collection"
                                :location="state.collectionLocation"
                                :selected-customer="state.localMovement.job.customer"
                                @location-changed="updateCollectionLocation"
                            />
                        </div>

                        <div class="form-group">
                            <label for="collection_company">
                                <strong>
                                    Collection Company
                                </strong>
                            </label>
                            <input
                                class="form-control"
                                placeholder="Name of company if different from Customer"
                                name="collection_company"
                                v-model="state.collectionCompany"
                                type="text"
                                id="collection_company"
                            >
                        </div>
                    </fieldset>
                </AdminBlock>
            </div>

            <div class="col-lg-6">
                <AdminBlock title="Delivery">
                    <fieldset class="">
                        <div class="form-group mb-4">
                            <label for="delivery_date">
                                <strong>
                                    Delivery Date
                                </strong>
                            </label>
                            <div class="input-group datetime collection-date">
                                <span class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                <input
                                    class="form-control js-flatpickers"
                                    placeholder="yyyy-mm-dd"
                                    id="delivery_date"
                                    name="delivery_date"
                                    v-model="state.deliveryDate"
                                    type="date"
                                >
                            </div>
                        </div>

                        <div class="form-group mb-4">
                            <JobTime
                                title="Delivery Time"
                                :time="state.deliveryTime"
                                @update-time="val => { state.deliveryTime = val }"
                            />
                        </div>

                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Delivery Location
                                </strong>
                            </label>

                            <GoogleMap
                                map-for="delivery"
                                :location="state.deliveryLocation"
                                :selected-customer="state.localMovement.job.customer"
                                @location-changed="updateDeliveryLocation"
                            />
                        </div>

                        <div class="form-group">
                            <label>
                                <strong>
                                    Delivery Company
                                </strong>
                            </label>
                            <input
                                class="form-control"
                                placeholder="Name of company if different from Customer"
                                name="delivery_company"
                                v-model="state.deliveryCompany"
                                type="text"
                                id="delivery_company"
                            >
                        </div>
                    </fieldset>
                </AdminBlock>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <AdminBlock title="Route">
                    <EstimateRoute
                        :collection="{
                            lat: state.collectionLatitude,
                            lng: state.collectionLongitude
                        }"
                        :delivery="{
                            lat: state.deliveryLatitude,
                            lng: state.deliveryLongitude
                        }"
                        :mileage="state.mileage"
                        @update-mileage="mileage => { state.mileage = mileage }"
                    />
                </AdminBlock>
            </div>

            <div class="col-lg-6">
                <div class="row">
                    <div class="col-12">
                        <AdminBlock title="Driver Notes">
                            <label for="driver_notes">
                                <strong>Driver Notes</strong>
                            </label>
                            <textarea
                                id="driver_notes"
                                class="form-control"
                                rows="3"
                                v-model="state.driverNotes"
                                placeholder="Enter notes for the driver here..."
                            ></textarea>
                        </AdminBlock>
                    </div>
                    <div class="col-12" v-if="jobHasOneMovement || jobFirstMovement || jobLastMovement">
                        <AdminBlock title="Update Options">
                            <div v-if="jobHasOneMovement" class="me-2 align-self-center">
                                <input type="checkbox" id="updateJobDetails" v-model="state.updateJobCollectionAndDelivery">
                                <label for="updateJobDetails" class="ms-1">Update Job Collection & Delivery?</label>
                                <HelperPopover
                                    title="Update Job Collection and Delivery Help"
                                    content="<p class='mb-2'>This sets the Collection and Delivery details on the Job to match the details being submitted to the Movement.</p><p class='mb-0'>It is <strong>STRONGLY</strong> recommended to keep this checked so that details are kept in sync between the Movement and Job.</p>"
                                />
                            </div>

                            <div v-if="jobFirstMovement" class="me-2 align-self-center">
                                <input type="checkbox" id="updateJobDetails" v-model="state.updateJobCollection">
                                <label for="updateJobDetails" class="ms-1">Update Job Collection?</label>
                                <HelperPopover
                                    title="Update Job Collection Help"
                                    content="<p class='mb-2'>This sets the Collection details on the Job to match the details being submitted to the Movement.</p><p class='mb-0'>It is <strong>STRONGLY</strong> recommended to keep this checked so that details are kept in sync between the Movement and Job.</p>"
                                />
                            </div>

                            <div v-if="jobLastMovement" class="me-2 align-self-center">
                                <input type="checkbox" id="updateJobDetails" v-model="state.updateJobDelivery">
                                <label for="updateJobDetails" class="ms-1">Update Job Collection & Delivery?</label>
                                <HelperPopover
                                    title="Update Job Delivery Help"
                                    content="<p class='mb-2'>This sets the Delivery details on the Job to match the details being submitted to the Movement.</p><p class='mb-0'>It is <strong>STRONGLY</strong> recommended to keep this checked so that details are kept in sync between the Movement and Job.</p>"
                                />
                            </div>
                        </AdminBlock>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <AdminBlock>
                <div class="d-flex justify-content-end">
                    <div class="me-2">
                        <a :href="generateJobLink()" class="btn btn-secondary btn-sm ">
                            Back to Job
                        </a>
                    </div>
                    <button @click="updateMovementRequest" id="create_contact_form_save" class="btn btn-primary btn-sm ">
                        Save
                    </button>
                </div>
            </AdminBlock>
        </div>
    </div>
</template>

<script setup>

import { reactive, computed, onMounted } from 'vue';
import axios from 'axios';
import flatpickr from "flatpickr";
import { successAlert, errorAlert, getDateString } from "@/utils";
import AdminBlock from '@/components/movements/components/AdminBlock.vue';
import EstimateRoute from "@/components/movements/components/EstimateRoute.vue";
import GoogleMap from "@/components/movements/components/GoogleMap.vue";
import JobTime from "@/components/movements/components/JobTime.vue";
import HelperPopover from "@//components/movements/components/HelperPopover.vue";

const props = defineProps({
    user: Object,
    movement: {
        type: Object,
        default: () => null,
        required: true
    },
    canEditRoute: {
        type: Boolean,
        default: false
    }
});

const state = reactive({
    localMovement: props.movement ?? {},
    localJob: props.movement?.job ?? {},
    driverNotes: props.movement?.driver_notes ?? '',
    selectedContract: props.movement?.job?.contract ?? null,
    selectedVehicle: props.movement?.job?.vehicle ?? null,
    collectionDate: getDateString(props.movement?.collection_date) ?? null,
    collectionTime: props.movement?.collection_time ?? null,
    collectionLocation: props.movement?.collection_location ?? null,
    collectionLocale: props.movement?.collection_locale ?? null,
    collectionLatitude: props.movement?.collection_lat ?? null,
    collectionLongitude: props.movement?.collection_lng ?? null,
    collectionCompany: props.movement?.collection_company ?? null,
    deliveryDate: getDateString(props.movement?.delivery_date) ?? null,
    deliveryTime: props.movement?.delivery_time ?? null,
    deliveryLocation: props.movement?.delivery_location ?? null,
    deliveryLocale: props.movement?.delivery_locale ?? null,
    deliveryLatitude: props.movement?.delivery_lat ?? null,
    deliveryLongitude: props.movement?.delivery_lng ?? null,
    deliveryCompany: props.movement?.delivery_company ?? null,
    mileage: props.movement?.job?.mileage ?? null,
    rateVehicletypeId: null,
    rateMinimumPrice: null,
    rateMinimumPriceMileage: null,
    priceIncludesFuel: null,
    priceIncludesAdblue: null,
    updateJobCollectionAndDelivery: true,
    updateJobCollection: true,
    updateJobDelivery: true,
});

onMounted(() => {

    flatpickr('.js-flatpickers', {
        dateFormat: "Y-m-d",
        enableTime: false,
        altInput: true,
    });

    flatpickr('.flatpicker-time-only', {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        altInput: true,
    });

    if (isSpecificTime(state.collectionTime)) {
        if (typeof $refs !== 'undefined' && $refs.collectionTimeSpecific) {
            $refs.collectionTimeSpecific._flatpickr.setDate(state.collectionTime);
        }
        state.collectionTime = 'Specific';
    }

    if (isSpecificTime(state.deliveryTime)) {
        if (typeof $refs !== 'undefined' && $refs.deliveryTimeSpecific) {
            $refs.deliveryTimeSpecific._flatpickr.setDate(state.deliveryTime);
        }
        state.deliveryTime = 'Specific';
    }

});

const jobHasOneMovement = computed(() => {
    return state.localJob?.movements && state.localJob.movements.length === 1;
});

const jobFirstMovement = computed(() => {
    return state.localJob && state.localJob.movements && state.localJob.movements.length > 1 &&
        state.localJob.movements[0].id === state.localMovement.id;
});

const jobLastMovement = computed(() => {
    return state.localJob && state.localJob.movements && state.localJob.movements.length > 1 &&
        state.localJob.movements.at(-1).id === state.localMovement.id;
});

const generateJobLink = () => {
    return route('movements.jobs.show', { 'job': state.localMovement.job.id });
};

const updateDeliveryLocation = (values) => {
    if (values.location !== null && values.location !== '') {
        state.deliveryLocation = values.location;
    }
    if (values.latitude !== null && values.longitude !== null) {
        state.deliveryLatitude = values.latitude;
        state.deliveryLongitude = values.longitude;
    }
    if (values.locale !== null && values.locale !== '') {
        state.deliveryLocale = values.locale;
    }
};

const updateCollectionLocation = (values) => {
    if (values.location !== null && values.location !== '') {
        state.collectionLocation = values.location;
    }
    if (values.latitude !== null && values.longitude !== null) {
        state.collectionLatitude = values.latitude;
        state.collectionLongitude = values.longitude;
    }
    if (values.locale !== null && values.locale !== '') {
        state.collectionLocale = values.locale;
    }
};

const isSpecificTime = (time) => {
    return time !== 'Any' &&
        time !== 'AM' &&
        time !== 'PM' &&
        time !== 'Evening' &&
        time !== 'Night';
};

const updateMovementRequest = () => {
    const data = {};
    data.driver_notes = state.driverNotes && state.driverNotes.length > 0 ? state.driverNotes : null;
    data.collection_date = state.collectionDate;
    data.collection_time = state.collectionTime;

    data.collection_location = state.collectionLocation;
    data.collection_lat = state.collectionLatitude;
    data.collection_lng = state.collectionLongitude;
    data.collection_locale = state.collectionLocale;
    data.collection_company = state.collectionCompany ?? null;

    data.delivery_date = state.deliveryDate;
    data.delivery_time = state.deliveryTime;

    data.delivery_location = state.deliveryLocation;
    data.delivery_lat = state.deliveryLatitude;
    data.delivery_lng = state.deliveryLongitude;
    data.delivery_locale = state.deliveryLocale;
    data.delivery_company = state.deliveryCompany ?? null;
    data.mileage = state.mileage;
    data.update_job_collection_and_delivery = state.updateJobCollectionAndDelivery;
    data.update_job_collection = state.updateJobCollection;
    data.update_job_delivery = state.updateJobDelivery;

    axios.patch(route('api.movements.movements.update', {'movement': state.localMovement.id}), data)
        .then(response => {
            state.localMovement = response.data.movement;
            successAlert('Movement Updated Successfully', 'Success')
                .then(() => {
                    window.location.href = route('movements.movements.show', { 'movement': props.movement.id });
                });
        })
        .catch(error => {
            errorAlert(error, 'Error Updating Movement');
        });
}

</script>
